document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".ck-feedback-slider");
  const slides = Array.from(document.querySelectorAll(".ck-feedback-slide"));
  const container = document.querySelector(".ck-feedback-slider-container");
  const avatarsContainer = document.querySelector(
    ".ck-feedback-slider-navigation"
  );
  let avatars = Array.from(document.querySelectorAll(".ck-author-image"));

  const maxHeight = Math.max(...slides.map((slide) => slide.offsetHeight));
  slider.style.minHeight = `${maxHeight}px`;

  slides.forEach((el, i) => (el.dataset.index = i.toString()));
  avatars.forEach((el, i) => (el.dataset.index = i.toString()));

  let currentIndex = Math.floor(slides.length / 2);

  function renderActiveSlide(index) {
    const centerPos = Math.floor(avatars.length / 2);
    const nextSlide = slides[index];
    const currentSlide = document.querySelector(".ck-feedback-slide.active");

    if (currentSlide && currentSlide !== nextSlide) {
      currentSlide.classList.remove("active");
      currentSlide.classList.add("slide-out-left");
      setTimeout(() => {
        currentSlide.classList.remove("slide-out-left");
      }, 500);
    }

    slides.forEach((slide) => slide.classList.remove("active"));
    if (nextSlide) nextSlide.classList.add("active");

    if (avatars.length > 1) {
      while (parseInt(avatars[centerPos].dataset.index) !== index) {
        avatars.push(avatars.shift());
      }

      // avatars.forEach((avatar) => avatarsContainer.appendChild(avatar));
      avatars.forEach((el) => el.classList.remove("active"));
      avatars[centerPos].classList.add("active");
    }

    currentIndex = index;
  }

  avatars.forEach((avatar, index) => {
    avatar.addEventListener("click", () => {
      const avatarIndex = parseInt(avatar.dataset.index);
      renderActiveSlide(avatarIndex);
    });
  });

  let touchStartX = 0;
  let touchEndX = 0;

  function handleSwipeGesture() {
    const swipeThreshold = 50; // Minimum px to consider a swipe
    if (touchEndX < touchStartX - swipeThreshold) {
      // Swipe left
      const nextIndex = (currentIndex + 1) % slides.length;
      renderActiveSlide(nextIndex);
    }
    if (touchEndX > touchStartX + swipeThreshold) {
      // Swipe right
      const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
      renderActiveSlide(prevIndex);
    }
  }

  slider.addEventListener("touchstart", (e) => {
    touchStartX = e.changedTouches[0].screenX;
  });

  slider.addEventListener("touchend", (e) => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipeGesture();
  });

  renderActiveSlide(currentIndex);
  // Autoplay
  function startAutoplay() {
    autoplayInterval = setInterval(() => {
      const nextIndex = (currentIndex + 1) % slides.length;
      renderActiveSlide(nextIndex, "left");
    }, 5000);
  }

  function stopAutoplay() {
    clearInterval(autoplayInterval);
  }

  if (
    container &&
    container.classList.contains("ck-feedback-slider-autoplay")
  ) {
    container.addEventListener("mouseenter", stopAutoplay);
    container.addEventListener("mouseleave", startAutoplay);
    startAutoplay();
  }
});
